interface Props {
  value: number;
  tone?: 'slate' | 'accent' | 'success' | 'danger';
  label?: string;
  className?: string;
}

const TONE = { slate: 'bg-slate', accent: 'bg-accent', success: 'bg-success', danger: 'bg-danger' } as const;

export default function Track({ value, tone = 'slate', label, className = '' }: Props) {
  const v = Math.max(0, Math.min(100, Number.isFinite(value) ? value : 0));
  return (
    <div role="progressbar" aria-label={label} aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(v)}
      className={`h-2 overflow-hidden rounded-full bg-track ${className}`}>
      <div className={`h-full rounded-full ${TONE[tone]}`} style={{ width: `${v}%` }} />
    </div>
  );
}
